module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_9.a907c102.jpg";